import { ModelBase } from "../shared/model.base";
import { GrupoDTO } from "../groups/grupoDTO.type";
import { ShortCode } from "../shared/shortcode.type";

export class SmsInstantDTO extends ModelBase {
    name: string;
    service_type: string;
    msisdn: string[];
    message: string;
    groups: GrupoDTO[];
    shortCode: ShortCode;
    longUrl: string;
    obfuscated: boolean;
    obfuscated_message: string;
    validityPeriod: number;
    template_id: number;

    constructor() {
        super();

        this.name = "";
        this.msisdn = new Array<string>();
        this.message = "";
    }
}
